import React from 'react';
import toast from 'react-hot-toast';
import { generateDownloadFilename } from '../../../../utils/fileUtils';

const FaceSwapPreviewModal = ({
  t,
  showPreviewModal,
  previewImageUrl,
  setShowPreviewModal
}) => {
  if (!showPreviewModal || !previewImageUrl) {
    return null;
  }

  const handleDownload = () => {
    const downloadUrl = previewImageUrl.url;
    fetch(downloadUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const filename = generateDownloadFilename(previewImageUrl.id);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${filename}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('Download image failed:', error);
        toast.error(t('aiWorkbench.faceSwap.messages.downloadFailed'));
      });
  };

  return (
    <div className="preview-modal-overlay" onClick={() => setShowPreviewModal(false)}>
      <div className="preview-modal" onClick={(e) => e.stopPropagation()}>
        <div className="preview-modal-header">
          <h3>{t('aiWorkbench.faceSwap.preview.title')}</h3>
          <button
            className="close-btn"
            onClick={() => setShowPreviewModal(false)}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        <div className="preview-modal-content">
          <img
            src={previewImageUrl.url}
            alt={t('aiWorkbench.faceSwap.preview.imageAlt')}
            className="preview-image"
          />
        </div>
        <div className="preview-modal-actions">
          <button
            className="download-btn"
            onClick={handleDownload}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7,10 12,15 17,10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            {t('aiWorkbench.faceSwap.buttons.download')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FaceSwapPreviewModal;

